import React, { useState, useEffect } from 'react';
import ActiveForm from './partials/ActiveForm'
import ValidatedForm from './partials/ValidatedForm';
import UnfilledForm from './partials/UnfilledForm';


const CarconditionForm = (props) => {
    const [selectedOption, setSelectedOption] = useState('');
    const [message, setMessage] = useState('');
    const { formValues, view } = props;

    const nextStep = e => {
        e.preventDefault();
        if (selectedOption) {
            props.handleSteps(2, { condition: formValues.condition }, 3)
        } else {
            setMessage('Du måste välja något av alternativen');
        }
    }

    const selectOption = (key, value) => e => {
        e.preventDefault();
        props.handleFormUpdates({ [key]: value });
        setSelectedOption(value);
    }

    useEffect(() => {
        setSelectedOption(formValues.condition);
    }, [view, formValues.condition])




    const content = {
        heading: 'Hur är bilens skick?',
        desc: ''
    }

    const options = [
        {
            name: 'mycket-bra-skick',
            title: 'Mycket bra skick',
            bullets: [
                'Inga repor eller skador',
                'Servad vid varje tillfälle med stämplar i serviceboken',
                'Däck med väldigt bra mönsterdjup (5-8 mm)',
            ]
        },
        {
            name: 'bra-skick',
            title: 'Bra skick',
            bullets: [
                'Några mindre repor',
                'Servad vid varje tillfälle med stämplar i serviceboken',
                'Däck som inte behöver bytas (mönsterdjup om 3-5 mm)',
            ]
        },
        {
            name: 'helt-ok-skick',
            title: 'Helt ok skick',
            bullets: [
                'Finns en del repor och mindre bucklor',
                'Däck som behöver bytas (mönsterdjup under 3 mm)',
                'Inte fullgod servicehistorik',
            ]
        },
        {
            name: 'daligt-skick',
            title: 'Dåligt skick',
            bullets: [
                'Finns repor och bucklor',
                'Däck som behöver bytas (mönsterdjup under 3 mm)',
                'Inte fullgod servicehistorik',
                'Spricka eller stenskott i vindruta'
            ]
        },
    ]




    switch (view) {
        case 'active':
            const form = (
                <React.Fragment>
                    <div className="form-fields carcondition">
                        {options.map((opt) => {
                            let selected = ''
                            opt.title === selectedOption ? selected = 'selected' : selected = '';
                            return (
                                <div className={'form-option ' + selected} key={opt.name}>
                                    <div className="field-title">
                                        {opt.title}
                                    </div>
                                    <ul>
                                        {opt.bullets.map((bullet, index) => {
                                            let key = opt.name + index;
                                            return (
                                                <li key={key}>
                                                    {bullet}
                                                </li>

                                            )
                                        })}
                                    </ul>
                                    <div className="form-separator"></div>
                                    <div className="button-container">
                                        <button className="form-button red" onClick={selectOption('condition', opt.title)}>Välj</button>
                                    </div>

                                </div>

                            )
                        })}
                    </div>

                    <div className="form-message">{message}</div>

                    <div className="form-button-container">
                        <button className="form-button-wide" disabled={selectedOption === ''} onClick={nextStep}>Nästa</button>
                    </div>

                </React.Fragment>
            );
            return (<ActiveForm content={content} form={form} step={2} />)
        case 'unfilled': return (<UnfilledForm content={content} step={2} />)
        case 'validated': return (<ValidatedForm content={content} step={2} values={[formValues.condition]} setStep={props.setStep} />)
        default: return (<div>Default</div>)
    }

}


export default CarconditionForm
